var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getstart-only-form-wrapper",class:{
    'trans-bg': _vm.transparentBgColor,
  }},[_c('Nuxt'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.displayFormInIframe),expression:"!displayFormInIframe"}]},[_c('CookieBanner',{ref:"banner",on:{"init":_vm.handleCookieBannerInit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }